import { render } from "./WalletExchangeTransferDetails.vue?vue&type=template&id=76b97d59&scoped=true"
import script from "./WalletExchangeTransferDetails.vue?vue&type=script&lang=js"
export * from "./WalletExchangeTransferDetails.vue?vue&type=script&lang=js"

import "./WalletExchangeTransferDetails.vue?vue&type=style&index=0&id=76b97d59&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b97d59"]])

export default __exports__